import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import styled from 'styled-components';
import { Anchor } from './copyright-and-policy-links/CopyrightAndPolicyLinks.style';
import { IconLink } from './social-links/SocialLinks.style';

export const FooterContainer = styled.footer`
  padding-top: 30px;
  padding-bottom: 50px;
  background-color: #d9d9d9;

  ${IconLink} img {
    width: 100%;
    max-width: 20px;
    filter: invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%);

    &:hover {
      filter: invert(44%) sepia(62%) saturate(3918%) hue-rotate(314deg) brightness(94%) contrast(98%);
    }
  }

  ${Anchor} {
    &:hover p {
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const Logo = styled.img`
  width: 240px;
  height: 33px;
  cursor: pointer;
`;

export const CopyrightWrapper = styled(PageWrapper)`
  margin-top: 35px;
`;
